import React from 'react';
import { Badge } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { Warning } from '@mui/icons-material';

import BeSafeTooltip from 'components/commons/BeSafeTooltip';
import TimestampFormat from 'components/TimestampFormat';

const ArgusLicenseStatus = ({ info }) => {
  if (!info) return null;

  if (!info.has_license) {
    return (
      <Badge variant="danger">
        <FormattedMessage id="USER_OBJECTS.ARGUS_LICENSE_NO_LICENSE" />
      </Badge>
    );
  }

  const expiresAt = moment.unix(info.expires_at);
  const closeToExpiry = expiresAt.diff(moment(), 'month') <= 1;
  const seatsExhausted = info.available_seats === 0;

  return (
    <div>
      <Badge variant="success" className="mr-2">
        <FormattedMessage id="USER_OBJECTS.ARGUS_LICENSE_ACTIVE" />
      </Badge>
      {closeToExpiry && (
        <BeSafeTooltip
          placement="right"
          tooltip={<FormattedMessage id="LICENSES.CLOSE_TO_EXPIRY_TOOLTIP" />}
        >
          <Warning color="warning" fontSize="small" />
        </BeSafeTooltip>
      )}
      <FormattedMessage
        id="USER_OBJECTS.ARGUS_LICENSE_ACTIVE_UNTIL"
        values={{
          date: <TimestampFormat date={expiresAt.toDate()} type="date" />,
        }}
      />
      <div className={seatsExhausted ? 'text-danger' : 'text-muted'}>
        <FormattedMessage
          id="USER_OBJECTS.ARGUS_SEATS_RATIO"
          values={{ used: info.used_seats, total: info.total_seats }}
        />
      </div>
    </div>
  );
};

export default ArgusLicenseStatus;
